module.exports = __webpack_public_path__ + "img/online_bg.db60be07.png";